import * as at from "./actionTypes";
import {reduxStore} from "../../angularReactRedux/reduxStore";
import apiClient from '../../../services/session/apiClient'

const state = () => reduxStore.getState().manageTool

export function checkLoadJobTypes() {
  if (state().jobTypesLoading) {
    apiClient.get('/manageTool/jobTypes').then(resp => {
      reduxStore.dispatch({
        type: at.SET_JOB_TYPES,
        jobTypes: resp.data
      })
    })
  }
}

export function submitQuery() {


  reduxStore.dispatch({
    type: at.LOADING_ENTRIES
  })

  apiClient
    .post('/manageTool/keys/' + state().selectedJobLevel, state().query)
    .then(resp => {
      reduxStore.dispatch({
        type: at.SET_ENTRIES,
        entries: resp.data,
      })
    })
}


export function loadHistory(jobType, jobKey) {
  return apiClient.post('/manageTool/getHistory', {key: jobKey, jobType})
    .then(x => x.data)
}

export function queue({priority, skipRequirements = false, jumpQueue = false}) {
  const jobType = state().selectedJobType
  const args = state()
    .entries
    .filter(x => x.selected)
    .map(e => {
      return {
        args: {
          jobType,
          key: e.key
        },
        priority: priority,
        skipRequirements,
        jumpQueue
      }
    })
  reduxStore.dispatch({type: at.SET_JOBS_QUEUED_PENDING, count: args.length});
  apiClient.post('/manageTool/queue', args)
    .then(x => {
      reduxStore.dispatch({
        type: at.SET_JOBS_QUEUED,
        summary: {
          message: `Queued ${args.length} Jobs`,
          status: 'success'
        }
      })
    })
    .catch(x => {
      console.error(x)
      reduxStore.dispatch({
        type: at.SET_JOBS_QUEUED,
        summary: {
          message: `Uh-oh! Failed to Queue Jobs`,
          status: 'danger'
        }
      })
    })


}








